import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  FlavorType,
  MineralWaterProperties as MineralWaterProperty,
} from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { MineralWaterProperties } from '@app/api/models';

@Component({
  selector: 'app-mineral-water-properties-subform',
  styleUrls: ['./mineral-water-properties-subform.component.scss'],
  templateUrl: './mineral-water-properties-subform.component.html',
})
export class MineralWaterPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.MINERAL_WATER_PROPERTIES';

  sourceType = MineralWaterProperty.SourceTypeEnum;
  flavorType = FlavorType;
  acidityLevel = MineralWaterProperty.AcidityLevelEnum;

  static buildForm(fb: FormBuilder, data?: MineralWaterProperties) {
    return fb.group({
      sourceType: [data?.sourceType, Validators.required],
      flavored: [data?.flavored],
      ...(data?.flavorTypes && {
        flavorTypes: [data?.flavorTypes, Validators.required],
      }),
      acidityLevel: [data?.acidityLevel, Validators.required],
      containsAddedSugar: [data?.containsAddedSugar ?? false],
      containsAddedSweetener: [data?.containsAddedSweetener ?? false],
    });
  }

  onFlavoredChange(flavored: boolean) {
    if (flavored) {
      this.group.addControl(
        'flavorTypes',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.group.removeControl('flavorTypes');
    }
  }
}
